<template>
  <a :href="ad.linkUrl || '#'" target="_blank" rel="noopener" class="ad-card" @click="onClick">
    <span class="ad-tag">{{ $t('layout.ad.promo') }}</span>
    <div class="card-img-wrap">
      <img :src="ad.imageUrl" :alt="ad.name" />
    </div>
    <div class="card-body">
      <h4 class="card-name">{{ ad.name }}</h4>
    </div>
    <div class="card-footer">
      <span class="footer-label"><i class="el-icon-present" /> {{ $t('layout.ad.recommend') }}</span>
    </div>
  </a>
</template>

<script>
import { recordAdClick } from '@/api/site'

export default {
  props: {
    ad: { type: Object, required: true },
    tool: { type: Object, default: null }
  },
  methods: {
    onClick() {
      recordAdClick({
        adId: this.ad.id,
        adName: this.ad.name,
        toolId: this.tool ? this.tool.id : null,
        toolName: this.tool ? this.tool.name : null,
        categoryName: this.tool ? this.tool.categoryName : null,
        pageType: this.ad.pageType || ''
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.ad-card {
  display: flex; flex-direction: column;
  background: #fff; border-radius: 12px;
  padding: 24px 20px 16px;
  transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
  border: 1px solid #ebeef5;
  height: 100%; min-height: 200px; box-sizing: border-box;
  position: relative; text-decoration: none; color: inherit;
}
.ad-card:hover {
  box-shadow: 0 8px 24px rgba(78,124,255,0.12);
  border-color: #4e7cff; transform: translateY(-4px);
}

.ad-tag {
  position: absolute; top: 8px; right: 10px;
  font-size: 10px; color: rgba(255,255,255,0.85);
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(4px);
  padding: 1px 6px; border-radius: 3px;
  z-index: 2; letter-spacing: 0.5px;
}

.card-img-wrap {
  width: 100%; height: 100px;
  border-radius: 8px; overflow: hidden;
  margin-bottom: 14px; flex-shrink: 0;
  background: #f5f6f8;
  display: flex; align-items: center; justify-content: center;
}
.card-img-wrap img {
  width: 100%; height: 100%; object-fit: cover;
}

.card-body { flex: 1; min-width: 0; margin-bottom: 10px; }
.card-name {
  margin: 0; font-size: 16px; font-weight: 700; color: #1a1f36; line-height: 1.3;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}

.card-footer {
  display: flex; align-items: center;
  padding-top: 10px; border-top: 1px solid #f2f3f5; flex-shrink: 0;
}
.footer-label {
  font-size: 12px; color: #b0b8c4; display: flex; align-items: center; gap: 3px;
}
</style>
